import { takeLatest, put, all, call } from 'redux-saga/effects';

import DashboardTypes from './dashboard.types';
import {
	dashboardDetailsGet,
	dashboardDetailsLoanTypeGet,
	loanDetailsGet,
	loanIndexDetailsGet,
	companyEodStatusGet,
	rejectMemberListCall,
	dashboardParticularListCall,
	dashboardStaffCollectionListCall,
	dashboardStaffLocationListCall,
	dashboardParticularDateDemandListCall,
	dashboardParticularDateDemandMemberListCall,
	dashboardParticularDateMemberAbsentListCall,
	dashboardParticularDateCollectionListCall,
	dashboardParticularMemberCollectionListCall,
	dashboardWeekCollectionListCall,
	dashboardWeekYTCollectionListCall,
	smsUsedListCall,
	kycUsedListCall,
	arrearCollectionListCall,
	dashboardStaffMapCollectionCall,
	dashboardCollectionNoteInfoCall,
	getDashboardSavingsAndFDGet,
	getBranchTotalInvestmentAmountGet,
	getDashboardTotalBranchMemberGet,
	getBranchTotalOLBAmountGet,
	getTotalCollectionGet,
	getDashboardAmountBasedonlocationGet,
	getDashboardZeroCollectionDetailsGet,
	getOnlineStaffDetailsGet,
	getOfficerLiveStatusCall,
	getGoldLoanCardDetailsGet,
	getGoldLoanDashboardLoanDetailsGet,
	getGoldLoanLoanIndexDetailsGet,
} from './dashboard.services';
import {
	getLoanDetailsSuccess,
	getLoanDetailsFailure,
	getLoanDetailsResponseChanged,
	getDashboardCardDetailsSuccess,
	getDashboardCardDetailsFailure,
	getDashboardCardDetailsResponseChanged,
	getDashboardDetailsLoanTypeSuccess,
	getDashboardDetailsLoanTypeFailure,
	getDashboardDetailsLoanTypeResponseChanged,
	getLoanIndexDetailsSuccess,
	getLoanIndexDetailsFailure,
	getLoanIndexDetailsResponseChanged,
	companyEodStatusSuccess,
	companyEodStatusFailure,
	companyEodStatusResponseChanged,
	rejectedMemberListSuccess,
	rejectedMemberListFailure,
	rejectedMemberListResponseChanged,
	getDashboardParticularDetailsSuccess,
	getDashboardParticularDetailsFailure,
	getDashboardParticularDetailsChanged,
	getDashboardStaffCollectionSuccess,
	getDashboardStaffCollectionFailure,
	getDashboardStaffCollectionChanged,
	getStaffLocationSuccess,
	getStaffLocationFailure,
	getStaffLocationChanged,
	// DEMAND SECTION
	getParticularDateDemandSuccess,
	getParticularDateDemandFailure,
	getParticularDateDemandChanged,
	getParticularDateDemandInfoSuccess,
	getParticularDateDemandInfoFailure,
	getParticularDateDemandInfoChanged,
	getParticularDateMemberAbsentSuccess,
	getParticularDateMemberAbsentFailure,
	getParticularDateMemberAbsentChanged,
	// COLLECTION SECTION
	getParticularDateCollectionSuccess,
	getParticularDateCollectionFailure,
	getParticularDateCollectionChanged,
	getParticularDateCollectionInfoSuccess,
	getParticularDateCollectionInfoFailure,
	getParticularDateCollectionInfoChanged,
	getWeekCollectionSuccess,
	getWeekCollectionFailure,
	getWeekCollectionChanged,
	getWeekYTCollectionSuccess,
	getWeekYTCollectionFailure,
	getWeekYTCollectionChanged,
	getSMSUsedListSuccess,
	getSMSUsedListFailure,
	getSMSUsedListChanged,
	getKYCUsedListSuccess,
	getKYCUsedListFailure,
	getKYCUsedListChanged,
	getArrearCollectionListSuccess,
	getArrearCollectionListFailure,
	getArrearCollectionListChanged,
	getDashboardStaffMapCollectionSuccess,
	getDashboardStaffMapCollectionFailure,
	getDashboardStaffMapCollectionChanged,
	getDashboardCollectionNoteInfoSuccess,
	getDashboardCollectionNoteInfoFailure,
	getDashboardCollectionNoteInfoChanged,
	getDashboardSavingsAndFDFailure,
	getDashboardSavingsAndFDSuccess,
	getDashboardSavingsAndFDChanged,
	getDashboardTotalBranchMemberSuccess,
	getDashboardTotalBranchMemberFailure,
	getDashboardTotalBranchMemberChanged,
	getBranchTotalInvestmentAmountFailure,
	getBranchTotalInvestmentAmountSuccess,
	getBranchTotalInvestmentAmountChanged,
	getBranchTotalOLBAmountFailure,
	getBranchTotalOLBAmountSuccess,
	getBranchTotalOLBAmountChanged,
	getTotalCollectionFailure,
	getTotalCollectionSuccess,
	getTotalCollectionChanged,
	getDashboardAmountBasedonlocationFailure,
	getDashboardAmountBasedonlocationSuccess,
	getDashboardAmountBasedonlocationChanged,
	getDashboardZeroCollectionDetailsFailure,
	getDashboardZeroCollectionDetailsSuccess,
	getDashboardZeroCollectionDetailsChanged,
	getOnlineStaffDetailsChanged,
	getOnlineStaffDetailsFailure,
	getOnlineStaffDetailsSuccess,
	getOfficerLiveStatusSuccess,
	getOfficerLiveStatusFailure,
	getOfficerLiveStatusChanged,
	getGoldLoanDashboardLoanDetailsFailure,
	getGoldLoanDashboardLoanDetailsSuccess,
	getGoldLoanCardDetailsSuccess,
	getGoldLoanCardDetailsFailure,
	getGoldLoanCardDetailsResponseChanged,
	getGoldLoanDashboardLoanDetailsResponseChanged,
	getGoldLoanLoanIndexDetailsSuccess,
	getGoldLoanLoanIndexDetailsFailure,
	getGoldLoanLoanIndexDetailsResponseChanged,
} from './dashboard.action';
import { encryptData } from '../_common/enode-decode';

import AlertManager from '../../utils/alertManager';
/** *********************  START DASHBOARD CARD DETAILS START  ******************** */
export function* getDashboardDetails({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			userLevel,
			userAccessBranchID,
			userID,
			CurrentFinancialYearDataOnDashboard = 0,
		} = payload;
		const key = 'DashboardCardDetailsFetchKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			Level: userLevel,
			AreaID: userAccessBranchID,
			UserID: userID,
			CurrentFinancialYearDataOnDashboard: CurrentFinancialYearDataOnDashboard,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dashboardDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getDashboardCardDetailsFailure(responseData.data));
		} else {
			yield put(getDashboardCardDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getDashboardCardDetailsFailure(error));
	}
}

export function* resetDashboardDetailsResponse() {
	yield put(getDashboardCardDetailsResponseChanged());
}

export function* onGetDashboardDetails() {
	yield takeLatest(DashboardTypes.GET_DASHBOARD_CARD_DETAILS_START, getDashboardDetails);
}

export function* onGetDashboardDetailsResponseReset() {
	yield takeLatest(
		DashboardTypes.GET_DASHBOARD_CARD_DETAILS_RESPONSE_RESET,
		resetDashboardDetailsResponse,
	);
}

/** ********************* DASHBOARD CARD DETAILS END   ******************** */

/** *********************  REJECT MEMBER LIST  ******************** */
export function* rejectMemberList({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			userLevel,
			userAccessBranchID,
			userID,
			userRole,
			RejectedReason,
		} = payload;
		const key = 'RejectedMembersDetailsKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			Level: userLevel,
			BranchID: userAccessBranchID,
			CenterID: 'All',
			UserID: userID,
			UserRole: userRole,
			RejectedReason: RejectedReason,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(rejectMemberListCall, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(rejectedMemberListFailure(responseData.data));
		} else {
			yield put(rejectedMemberListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(rejectedMemberListFailure(error));
	}
}

export function* resetRejectMemberList() {
	yield put(rejectedMemberListResponseChanged());
}

export function* onRejectMemberList() {
	yield takeLatest(DashboardTypes.REJECT_MEMBER_LIST_START, rejectMemberList);
}

export function* onRejectMemberListResponseReset() {
	yield takeLatest(DashboardTypes.REJECT_MEMBER_LIST_RESET, resetRejectMemberList);
}

/** *********************  END REJECT MEMBER LIST   ******************** */

/** *********************  START LOAN DETAILS LIST  ******************** */
export function* getLoanDetails({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			userLevel,
			loanType,
			userID,
			userRole,
			SetWeekArray,
			byCenterGroup,
			branchID,
		} = payload;
		const key = 'DashboardLoanDeatilsKey';
		const jsonData = {
			UserID: userID,
			CompanyID: companyID,
			UserRoleName: userRole,
			UserLevel: userLevel,
			LoanType: loanType,
			SetWeekArray: SetWeekArray,
			DatabaseName: databaseName,
			ByCenterGroup: byCenterGroup,
			BranchID: branchID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(loanDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getLoanDetailsFailure(responseData.data));
		} else {
			yield put(getLoanDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getLoanDetailsFailure(error));
	}
}

export function* resetLoanDetailsResponse() {
	yield put(getLoanDetailsResponseChanged());
}

export function* onGetLoanDetails() {
	yield takeLatest(DashboardTypes.GET_LOAN_DETAILS_START, getLoanDetails);
}

export function* onGetLoanDetailsResponseReset() {
	yield takeLatest(DashboardTypes.GET_LOAN_DETAILS_RESPONSE_RESET, resetLoanDetailsResponse);
}

/** *********************  END LOAN DETAILS LIST  ******************** */

/** *********************  START LOAN DETAILS LIST  ******************** */
export function* getDashboardDetailsLoanType({ payload }: any) {
	try {
		const { databaseName, companyID, userLevel, userAccessBranchID, userID, LoanType } =
			payload;
		const key = 'DashboardDetailsLoanTypeKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			Level: userLevel,
			AreaID: userAccessBranchID,
			UserID: userID,
			LoanType: LoanType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dashboardDetailsLoanTypeGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getDashboardDetailsLoanTypeFailure(responseData.data));
		} else {
			yield put(getDashboardDetailsLoanTypeSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getDashboardDetailsLoanTypeFailure(error));
	}
}

export function* resetDashboardDetailsLoanTypeResponse() {
	yield put(getDashboardDetailsLoanTypeResponseChanged());
}

export function* onGetDashboardDetailsLoanType() {
	yield takeLatest(
		DashboardTypes.GET_DASHBOARD_DETAILS_LOAN_TYPE_START,
		getDashboardDetailsLoanType,
	);
}

export function* onGetDashboardDetailsLoanTypeResponseReset() {
	yield takeLatest(
		DashboardTypes.GET_DASHBOARD_DETAILS_LOAN_TYPE_RESPONSE_RESET,
		resetDashboardDetailsLoanTypeResponse,
	);
}

/** *********************  END LOAN DETAILS LIST  ******************** */

/** *********************  START LOAN INDEX DETAILS LIST  ******************** */
export function* getLoanIndexDetails({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			userLevel,
			loanType,
			userID,
			userRole,
			SetWeekArray,
			limit,
			searchValueSet,
			branchID,
		} = payload;
		const key = 'DashboardLoanIndexDetailsKey';
		const jsonData = {
			UserID: userID,
			CompanyID: companyID,
			UserRoleName: userRole,
			UserLevel: userLevel,
			LoanType: loanType,
			SetWeekArray: SetWeekArray,
			DatabaseName: databaseName,
			Limit: limit,
			SearchLoanIndex: searchValueSet,
			BranchID: branchID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(loanIndexDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getLoanIndexDetailsFailure(responseData.data));
		} else {
			yield put(getLoanIndexDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getLoanIndexDetailsFailure(error));
	}
}

export function* resetLoanIndexDetailsResponse() {
	yield put(getLoanIndexDetailsResponseChanged());
}

export function* onGetLoanIndexDetails() {
	yield takeLatest(DashboardTypes.GET_LOAN_INDEX_DETAILS_START, getLoanIndexDetails);
}

export function* onGetLoanIndexDetailsResponseReset() {
	yield takeLatest(
		DashboardTypes.GET_LOAN_INDEX_DETAILS_RESPONSE_RESET,
		resetLoanIndexDetailsResponse,
	);
}

/** *********************  END LOAN INDEX DETAILS LIST  ******************** */

// DEMAND SECTION

/** *********************  DASHBOARD PARTICULAR DATE DEMAND LIST  ******************** */
export function* dashboardParticularDateDemandList({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			userLevel,
			loanType,
			userID,
			userRole,
			byCenterGroup,
			funderID,
			branchID,
			centerID,
			payDay,
			date,
		} = payload;
		const key = 'ParticularDateGroupDemandInfoKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			ByCenterGroup: byCenterGroup,
			FunderID: funderID,
			LoanType: loanType,
			BranchID: branchID,
			CenterID: centerID,
			PayDay: payDay,
			WhenToPay: date,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dashboardParticularDateDemandListCall, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getParticularDateDemandFailure(responseData.data));
		} else {
			yield put(getParticularDateDemandSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getParticularDateDemandFailure(error));
	}
}

export function* resetDashboardParticularDateDemandList() {
	yield put(getParticularDateDemandChanged());
}

export function* onParticularDateDemand() {
	yield takeLatest(
		DashboardTypes.GET_PARTICULAR_DATE_DEMAND_START,
		dashboardParticularDateDemandList,
	);
}

export function* onParticularDateDemandResponseReset() {
	yield takeLatest(
		DashboardTypes.GET_PARTICULAR_DATE_DEMAND_RESET,
		resetDashboardParticularDateDemandList,
	);
}

/** *********************  END DASHBOARD PARTICULAR DATE DEMAND LIST   ******************** */

/** *********************  DASHBOARD PARTICULAR DATE DEMAND INFO LIST  ******************** */
export function* dashboardParticularDateDemandInfoList({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			userLevel,
			loanType,
			userID,
			userRole,
			byCenterGroup,
			funderID,
			branchID,
			centerID,
			payDay,
			date,
			groupID,
		} = payload;
		const key = 'ParticularDateGroupMemberInfoKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			ByCenterGroup: byCenterGroup,
			FunderID: funderID,
			LoanType: loanType,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			PayDay: payDay,
			WhenToPay: date,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dashboardParticularDateDemandMemberListCall, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getParticularDateDemandInfoFailure(responseData.data));
		} else {
			yield put(getParticularDateDemandInfoSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getParticularDateDemandInfoFailure(error));
	}
}

export function* resetDashboardParticularDateDemandInfoList() {
	yield put(getParticularDateDemandInfoChanged());
}

export function* onParticularDateDemandInfo() {
	yield takeLatest(
		DashboardTypes.GET_PARTICULAR_DATE_DEMAND_INFO_START,
		dashboardParticularDateDemandInfoList,
	);
}

export function* onParticularDateDemandInfoResponseReset() {
	yield takeLatest(
		DashboardTypes.GET_PARTICULAR_DATE_DEMAND_INFO_RESET,
		resetDashboardParticularDateDemandInfoList,
	);
}

/** *********************  END DASHBOARD PARTICULAR DATE DEMAND INFO LIST   ******************** */

/** *********************  DASHBOARD PARTICULAR DATE MEMBER ABSENT LIST  ******************** */
export function* dashboardParticularDateMemberAbsentList({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			userLevel,
			DateFilter,
			userID,
			userRole,
			fromDate,
			toDate,
			ligmID,
			memberID,
		} = payload;
		const key = 'DashboardMemberAbsentDetailsKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			DateFilter: DateFilter,
			FromDate: fromDate,
			LoanIndexGroupMemberID: ligmID,
			MemberID: memberID,
			ToDate: toDate,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dashboardParticularDateMemberAbsentListCall, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getParticularDateMemberAbsentFailure(responseData.data));
		} else {
			yield put(getParticularDateMemberAbsentSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getParticularDateMemberAbsentFailure(error));
	}
}

export function* resetDashboardParticularDateMemberAbsentList() {
	yield put(getParticularDateMemberAbsentChanged());
}

export function* onParticularDateMemberAbsent() {
	yield takeLatest(
		DashboardTypes.GET_PARTICULAR_DATE_MEMBER_ABSENT_START,
		dashboardParticularDateMemberAbsentList,
	);
}

export function* onParticularDateMemberAbsentResponseReset() {
	yield takeLatest(
		DashboardTypes.GET_PARTICULAR_DATE_MEMBER_ABSENT_RESET,
		resetDashboardParticularDateMemberAbsentList,
	);
}

/** *********************  END DASHBOARD PARTICULAR DATE MEMBER ABSENT LIST   ******************** */

/** *********************  DASHBOARD WEEK COLLECTION LIST  ******************** */
export function* dashboardWeekCollectionList({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			userLevel,
			loanType,
			userID,
			userRole,
			funderID,
			branchID,
			centerID,
			payDay,
			date,
		} = payload;
		const key = 'CollectionAmountBranchMemberWiseKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			FunderID: funderID,
			LoanType: loanType,
			BranchID: branchID,
			CenterID: centerID,
			PayDay: payDay,
			CollectionDate: date,
			CollectionMode: 'All',
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dashboardWeekCollectionListCall, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getWeekCollectionFailure(responseData.data));
		} else {
			yield put(getWeekCollectionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getWeekCollectionFailure(error));
	}
}

export function* resetDashboardWeekCollectionList() {
	yield put(getWeekCollectionChanged());
}

export function* onWeekCollection() {
	yield takeLatest(DashboardTypes.GET_WEEK_COLLECTION_START, dashboardWeekCollectionList);
}

export function* onWeekCollectionResponseReset() {
	yield takeLatest(DashboardTypes.GET_WEEK_COLLECTION_RESET, resetDashboardWeekCollectionList);
}

/** *********************  END DASHBOARD WEEK COLLECTION LIST   ******************** */

/** *********************  DASHBOARD WEEK YET TO COLLECTION LIST  ******************** */
export function* dashboardWeekYTCollectionList({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			userLevel,
			loanType,
			userID,
			userRole,
			funderID,
			branchID,
			centerID,
			payDay,
			date,
			ligms,
		} = payload;
		const key = 'GetParticularCollectionPendingGroupMemberKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			FunderID: funderID,
			LoanType: loanType,
			BranchID: branchID,
			CenterID: centerID,
			PayDay: payDay,
			WhenToPay: date,
			ValueType: 'Yet to Collect',
			LoanIndexGroupMemberIDs: ligms,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dashboardWeekYTCollectionListCall, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getWeekYTCollectionFailure(responseData.data));
		} else {
			yield put(getWeekYTCollectionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getWeekYTCollectionFailure(error));
	}
}

export function* resetDashboardWeekYTCollectionList() {
	yield put(getWeekYTCollectionChanged());
}

export function* onWeekYTCollection() {
	yield takeLatest(DashboardTypes.GET_WEEK_YT_COLLECTION_START, dashboardWeekYTCollectionList);
}

export function* onWeekYTCollectionResponseReset() {
	yield takeLatest(
		DashboardTypes.GET_WEEK_YT_COLLECTION_RESET,
		resetDashboardWeekYTCollectionList,
	);
}

/** *********************  END DASHBOARD WEEK YET TO COLLECTION LIST   ******************** */

/** *********************  DASHBOARD ARREAR COLLECTION LIST  ******************** */
export function* arrearCollectionList({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			userLevel,
			loanType,
			userID,
			userRole,
			funderID,
			branchID,
			centerID,
			payDay,
			date,
			ligms,
			valueType,
		} = payload;
		const key = 'DashboardArrearCollectionListKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			FunderID: funderID,
			LoanType: loanType,
			BranchID: branchID,
			CenterID: centerID,
			PayDay: payDay,
			WhenToPay: date,
			ValueType: valueType,
			LoanIndexGroupMemberIDs: ligms,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(arrearCollectionListCall, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getArrearCollectionListFailure(responseData.data));
		} else {
			yield put(getArrearCollectionListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getArrearCollectionListFailure(error));
	}
}

export function* resetArrearCollectionList() {
	yield put(getArrearCollectionListChanged());
}

export function* onGetArrearCollectionList() {
	yield takeLatest(DashboardTypes.ARREAR_COLLECTION_LIST_START, arrearCollectionList);
}

export function* onGetArrearCollectionListResponseReset() {
	yield takeLatest(DashboardTypes.ARREAR_COLLECTION_LIST_RESET, resetArrearCollectionList);
}

/** *********************  END DASHBOARD ARREAR COLLECTION LIST   ******************** */

/** *********************  DASHBOARD COLLECTION NOTE INFO  ******************** */
export function* dashboardCollectionNoteInfo({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			userLevel,
			WhenToPay,
			userID,
			userRole,
			LoanIndex,
			CenterID,
			GroupID,
			type,
		} = payload;
		const key = 'GetCollectionNotesInfoKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			WhenToPay: WhenToPay,
			LoanIndex: LoanIndex,
			CenterID: CenterID,
			GroupID: GroupID,
			Type: type,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dashboardCollectionNoteInfoCall, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getDashboardCollectionNoteInfoFailure(responseData.data));
		} else {
			yield put(getDashboardCollectionNoteInfoSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getDashboardCollectionNoteInfoFailure(error));
	}
}

export function* resetDashboardCollectionNoteInfo() {
	yield put(getDashboardCollectionNoteInfoChanged());
}

export function* onGetDashboardCollectionNoteInfoStart() {
	yield takeLatest(
		DashboardTypes.DASHBOARD_COLLECTION_NOTE_INFO_START,
		dashboardCollectionNoteInfo,
	);
}

export function* onGetDashboardCollectionNoteInfoStartResponseReset() {
	yield takeLatest(
		DashboardTypes.DASHBOARD_COLLECTION_NOTE_INFO_RESET,
		resetDashboardCollectionNoteInfo,
	);
}

/** *********************  END DASHBOARD COLLECTION NOTE INFO   ******************** */

/** *********************  START COMPANY EOD STATUS  ******************** */
export function* companyEodStatus({ payload }: any) {
	try {
		const { databaseName, companyID, date, limitEOD, branchID, userLevel } = payload;
		const key = 'GetCompanyEndOfDayStatusKey';
		const jsonData = {
			CompanyID: companyID,
			eodDate: date,
			BranchID: branchID,
			LimitEOD: limitEOD,
			Level: userLevel,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(companyEodStatusGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(companyEodStatusFailure(responseData.data));
		} else {
			yield put(companyEodStatusSuccess(responseData.data));
		}
	} catch (error) {
		yield put(companyEodStatusFailure(error));
	}
}

export function* resetCompanyEodStatusDetailsResponse() {
	yield put(companyEodStatusResponseChanged());
}

export function* onGetCompanyEodStatus() {
	yield takeLatest(DashboardTypes.COMPANY_EOD_STATUS_START, companyEodStatus);
}

export function* onGetCompanyEodStatusResponseReset() {
	yield takeLatest(
		DashboardTypes.COMPANY_EOD_STATUS_RESPONSE_RESET,
		resetCompanyEodStatusDetailsResponse,
	);
}

/** *********************  END COMPANY EOD STATUS ******************** */

/** *********************  DASHBOARD PARTICULAR LIST  ******************** */
export function* dashboardParticularList({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			userID,
			userRole,
			userLevel,
			branchID,
			centerID,
			funderID,
		} = payload;
		const key = 'DashboardCardBranchwiseKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			AreaID: branchID,
			LocationID: centerID,
			FunderID: funderID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dashboardParticularListCall, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getDashboardParticularDetailsFailure(responseData.data));
		} else {
			yield put(getDashboardParticularDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getDashboardParticularDetailsFailure(error));
	}
}

export function* resetDashboardParticularList() {
	yield put(getDashboardParticularDetailsChanged());
}

export function* onDashboardParticularDetails() {
	yield takeLatest(
		DashboardTypes.GET_DASHBOARD_PARTICULAR_DETAILS_START,
		dashboardParticularList,
	);
}

export function* onDashboardParticularDetailsResponseReset() {
	yield takeLatest(
		DashboardTypes.GET_DASHBOARD_PARTICULAR_DETAILS_RESET,
		resetDashboardParticularList,
	);
}
/** *********************  END DASHBOARD PARTICULAR LIST   ******************** */

/** *********************  DASHBOARD STAFF COLLECTION LIST  ******************** */
export function* dashboardStaffCollectionList({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			userID,
			userRole,
			userLevel,
			branchID,
			centerID,
			funderID,
		} = payload;
		const key = 'StaffTotalcollectionKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			BranchID: branchID,
			CenterID: centerID,
			FunderID: funderID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dashboardStaffCollectionListCall, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getDashboardStaffCollectionFailure(responseData.data));
		} else {
			yield put(getDashboardStaffCollectionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getDashboardStaffCollectionFailure(error));
	}
}

export function* resetDashboardStaffCollectionList() {
	yield put(getDashboardStaffCollectionChanged());
}

export function* onDashboardStaffCollection() {
	yield takeLatest(
		DashboardTypes.GET_DASHBOARD_STAFF_COLLECTION_START,
		dashboardStaffCollectionList,
	);
}

export function* onDashboardStaffCollectionResponseReset() {
	yield takeLatest(
		DashboardTypes.GET_DASHBOARD_STAFF_COLLECTION_RESET,
		resetDashboardStaffCollectionList,
	);
}

/** *********************  END DASHBOARD STAFF COLLECTION LIST   ******************** */

/** *********************  DASHBOARD STAFF LOCATION LIST  ******************** */
export function* dashboardStaffLocationList({ payload }: any) {
	try {
		const { databaseName, companyID, userID, userRole, userLevel, branchID } = payload;
		const key = 'GetCompanyBasedOnStaffLocationKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			BranchID: branchID !== undefined ? branchID : 0,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dashboardStaffLocationListCall, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getStaffLocationFailure(responseData.data));
		} else {
			yield put(getStaffLocationSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getStaffLocationFailure(error));
	}
}

export function* resetDashboardStaffLocationList() {
	yield put(getStaffLocationChanged());
}

export function* onDashboardStaffLocation() {
	yield takeLatest(DashboardTypes.GET_STAFF_LOCATION_START, dashboardStaffLocationList);
}

export function* onDashboardStaffLocationResponseReset() {
	yield takeLatest(DashboardTypes.GET_STAFF_LOCATION_RESET, resetDashboardStaffLocationList);
}

/** *********************  END DASHBOARD STAFF LOCATION LIST   ******************** */

// COLLECTION SECTION

/** *********************  DASHBOARD PARTICULAR DATE COLLECTION LIST  ******************** */
export function* dashboardParticularDateCollectionList({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			userID,
			userRole,
			userLevel,
			byCenterGroup,
			funderID,
			loanType,
			branchID,
			centerID,
			payDay,
			date,
		} = payload;
		const key = 'DashboardParticularDateGroupCollectionKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			ByCenterGroup: byCenterGroup,
			FunderID: funderID,
			LoanType: loanType,
			BranchID: branchID,
			CenterID: centerID,
			PayDay: payDay,
			WhenToPay: date,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dashboardParticularDateCollectionListCall, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getParticularDateCollectionFailure(responseData.data));
		} else {
			yield put(getParticularDateCollectionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getParticularDateCollectionFailure(error));
	}
}

export function* resetDashboardParticularDateCollectionList() {
	yield put(getParticularDateCollectionChanged());
}

export function* onParticularDateCollection() {
	yield takeLatest(
		DashboardTypes.GET_PARTICULAR_DATE_COLLECTION_START,
		dashboardParticularDateCollectionList,
	);
}

export function* onParticularDateCollectionResponseReset() {
	yield takeLatest(
		DashboardTypes.GET_PARTICULAR_DATE_COLLECTION_RESET,
		resetDashboardParticularDateCollectionList,
	);
}

/** *********************  END DASHBOARD PARTICULAR DATE COLLECTION LIST   ******************** */

/** *********************  DASHBOARD PARTICULAR DATE COLLECTION INFO LIST  ******************** */
export function* dashboardParticularDateCollectionInfoList({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			userID,
			userRole,
			userLevel,
			byCenterGroup,
			funderID,
			loanType,
			branchID,
			centerID,
			groupID,
			payDay,
			date,
		} = payload;
		const key = 'GetParticularDateGroupMemberCollectionKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			ByCenterGroup: byCenterGroup,
			FunderID: funderID,
			LoanType: loanType,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			PayDay: payDay,
			WhenToPay: date,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dashboardParticularMemberCollectionListCall, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getParticularDateCollectionInfoFailure(responseData.data));
		} else {
			yield put(getParticularDateCollectionInfoSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getParticularDateCollectionInfoFailure(error));
	}
}

export function* resetDashboardParticularDateCollectionInfoList() {
	yield put(getParticularDateCollectionInfoChanged());
}

export function* onParticularDateCollectionInfo() {
	yield takeLatest(
		DashboardTypes.GET_PARTICULAR_DATE_COLLECTION_INFO_START,
		dashboardParticularDateCollectionInfoList,
	);
}

export function* onParticularDateCollectionInfoResponseReset() {
	yield takeLatest(
		DashboardTypes.GET_PARTICULAR_DATE_COLLECTION_INFO_RESET,
		resetDashboardParticularDateCollectionInfoList,
	);
}

/** *********************  END DASHBOARD PARTICULAR DATE COLLECTION INFO LIST   ******************** */

/** *********************  DASHBOARD SMS USED LIST  ******************** */
export function* smsUsedList({ payload }: any) {
	try {
		const { databaseName, companyID, userID, userRole, userLevel, generalCompanyID } = payload;
		const key = 'DashboardSMSUsedListKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			GeneralCompanyID: generalCompanyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(smsUsedListCall, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getSMSUsedListFailure(responseData.data));
		} else {
			yield put(getSMSUsedListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getSMSUsedListFailure(error));
	}
}

export function* resetSMSUsedList() {
	yield put(getSMSUsedListChanged());
}

export function* onGetSMSUsedList() {
	yield takeLatest(DashboardTypes.SMS_USED_LIST_START, smsUsedList);
}

export function* onGetSMSUsedListResponseReset() {
	yield takeLatest(DashboardTypes.SMS_USED_LIST_RESET, resetSMSUsedList);
}

/** *********************  END DASHBOARD SMS USED LIST   ******************** */

/** *********************  DASHBOARD KYC USED LIST  ******************** */
export function* kycUsedList({ payload }: any) {
	try {
		const { databaseName, companyID, userID, userRole, userLevel, generalCompanyID } = payload;
		const key = 'DashboardKYCUsedListKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			GeneralCompanyID: generalCompanyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(kycUsedListCall, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getKYCUsedListFailure(responseData.data));
		} else {
			yield put(getKYCUsedListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getKYCUsedListFailure(error));
	}
}

export function* resetKYCUsedList() {
	yield put(getKYCUsedListChanged());
}

export function* onGetKYCUsedList() {
	yield takeLatest(DashboardTypes.KYC_USED_LIST_START, kycUsedList);
}

export function* onGetKYCUsedListResponseReset() {
	yield takeLatest(DashboardTypes.KYC_USED_LIST_RESET, resetKYCUsedList);
}

/** *********************  END DASHBOARD SMS USED LIST   ******************** */

/** *********************  DASHBOARD STAFF MAP COLLECTION  ******************** */
export function* dashboardStaffMapCollection({ payload }: any) {
	try {
		const { databaseName, companyID, userID, day } = payload;
		const key = 'DashboardStaffMapCollectionKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			Day: day,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dashboardStaffMapCollectionCall, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getDashboardStaffMapCollectionFailure(responseData.data));
		} else {
			yield put(getDashboardStaffMapCollectionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getDashboardStaffMapCollectionFailure(error));
	}
}

export function* resetDashboardStaffMapCollection() {
	yield put(getDashboardStaffMapCollectionChanged());
}

export function* onGetDashboardStaffMapCollectionStart() {
	yield takeLatest(
		DashboardTypes.DASHBOARD_STAFF_MAP_COLLECTION_START,
		dashboardStaffMapCollection,
	);
}

export function* onGetDashboardStaffMapCollectionStartResponseReset() {
	yield takeLatest(
		DashboardTypes.DASHBOARD_STAFF_MAP_COLLECTION_RESET,
		resetDashboardStaffMapCollection,
	);
}

/** *********************  END DASHBOARD STAFF MAP COLLECTION   ******************** */

/** *********************  START DASHBOARD SAVINGS AND FD  ******************** */
export function* getDashboardSavingsAndFD({ payload }: any) {
	try {
		const { databaseName, companyID, userID } = payload;
		const key = 'getDashBoardSavingsAndFDKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getDashboardSavingsAndFDGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getDashboardSavingsAndFDFailure(responseData.data));
		} else {
			yield put(getDashboardSavingsAndFDSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getDashboardSavingsAndFDFailure(error));
	}
}

export function* resetDashboardSavingsAndFDResponse() {
	yield put(getDashboardSavingsAndFDChanged());
}

export function* onGetDashboardSavingsAndFD() {
	yield takeLatest(DashboardTypes.GET_DASHBOARD_SAVINGS_FD_START, getDashboardSavingsAndFD);
}

export function* onGetDashboardSavingsAndFDResponseReset() {
	yield takeLatest(
		DashboardTypes.GET_DASHBOARD_SAVINGS_FD_RESET,
		resetDashboardSavingsAndFDResponse,
	);
}
/** *********************  END DASHBOARD SAVINGS AND FD  ******************** */

/** ********************* START DASHBOARD TOTAL BRANCH MEMBER ******************** */
export function* getDashboardTotalBranchMember({ payload }: any) {
	try {
		const { databaseName, companyID, userID, areaID, locationID } = payload;
		const key = 'GetDashboardTotalBranchMemberKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			AreaID: areaID,
			LocationID: locationID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getDashboardTotalBranchMemberGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getDashboardTotalBranchMemberFailure(responseData.data));
		} else {
			yield put(getDashboardTotalBranchMemberSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getDashboardTotalBranchMemberFailure(error));
	}
}

export function* resetDashboardTotalBranchMemberResponse() {
	yield put(getDashboardTotalBranchMemberChanged());
}

export function* onGetDashboardTotalBranchMember() {
	yield takeLatest(
		DashboardTypes.GET_DASHBOARD_TOTAL_BRANCH_MEMBER_START,
		getDashboardTotalBranchMember,
	);
}

export function* onGetDashboardTotalBranchMemberResponseReset() {
	yield takeLatest(
		DashboardTypes.GET_DASHBOARD_TOTAL_BRANCH_MEMBER_RESET,
		resetDashboardTotalBranchMemberResponse,
	);
}
/** ********************* END DASHBOARD TOTAL BRANCH MEMBER ******************** */

/** ********************* START BRANCH TOTAL INVESTMENT AMOUNT ******************** */
export function* getBranchTotalInvestmentAmount({ payload }: any) {
	try {
		const { databaseName, companyID, userID, branchID, funderID } = payload;
		const key = 'GetBranchTotalInvestmentAmountKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			BranchID: branchID,
			FunderID: funderID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getBranchTotalInvestmentAmountGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBranchTotalInvestmentAmountFailure(responseData.data));
		} else {
			yield put(getBranchTotalInvestmentAmountSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBranchTotalInvestmentAmountFailure(error));
	}
}

export function* resetBranchTotalInvestmentAmountResponse() {
	yield put(getBranchTotalInvestmentAmountChanged());
}

export function* onGetBranchTotalInvestmentAmount() {
	yield takeLatest(
		DashboardTypes.GET_BRANCH_TOTAL_INVESTMENT_AMOUNT_START,
		getBranchTotalInvestmentAmount,
	);
}

export function* onGetBranchTotalInvestmentAmountResponseReset() {
	yield takeLatest(
		DashboardTypes.GET_BRANCH_TOTAL_INVESTMENT_AMOUNT_RESET,
		resetBranchTotalInvestmentAmountResponse,
	);
}
/** ********************* END BRANCH TOTAL INVESTMENT AMOUNT ******************** */

/** ********************* START GET BRANCH TOTAL OLB AMOUNT ******************** */
export function* getBranchTotalOLBAmount({ payload }: any) {
	try {
		const { databaseName, companyID, userID, areaID, branchID, funderID } = payload;
		const key = 'GetBranchTotalOLBAmountKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			AreaID: areaID,
			BranchID: branchID,
			FunderID: funderID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getBranchTotalOLBAmountGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBranchTotalOLBAmountFailure(responseData.data));
		} else {
			yield put(getBranchTotalOLBAmountSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBranchTotalOLBAmountFailure(error));
	}
}

export function* resetBranchTotalOLBAmountResponse() {
	yield put(getBranchTotalOLBAmountChanged());
}

export function* onGetBranchTotalOLBAmount() {
	yield takeLatest(DashboardTypes.GET_BRANCH_TOTAL_OLB_AMOUNT_START, getBranchTotalOLBAmount);
}

export function* onGetBranchTotalOLBAmountResponseReset() {
	yield takeLatest(
		DashboardTypes.GET_BRANCH_TOTAL_OLB_AMOUNT_RESET,
		resetBranchTotalOLBAmountResponse,
	);
}
/** ********************* END GET BRANCH TOTAL OLB AMOUNT ******************** */

/** ********************* START GET TOTAL COLLECTION ******************** */
export function* getTotalCollection({ payload }: any) {
	try {
		const { databaseName, companyID, userID, areaID, locationID, funderID } = payload;
		const key = 'GetTotalCollectionAmountKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			AreaID: areaID,
			LocationID: locationID,
			FunderID: funderID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getTotalCollectionGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getTotalCollectionFailure(responseData.data));
		} else {
			yield put(getTotalCollectionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getTotalCollectionFailure(error));
	}
}

export function* resetTotalCollectionResponse() {
	yield put(getTotalCollectionChanged());
}

export function* onGetTotalCollection() {
	yield takeLatest(DashboardTypes.GET_TOTAL_COLLECTION_START, getTotalCollection);
}

export function* onGetTotalCollectionResponseReset() {
	yield takeLatest(DashboardTypes.GET_TOTAL_COLLECTION_RESET, resetTotalCollectionResponse);
}
/** ********************* END GET TOTAL COLLECTION ******************** */

export function* getDashboardAmountBasedonlocation({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			userID,
			centerID,
			branchID,
			funderID,
			userLevel,
			loanType,
			SetWeekArray,
			byCenterGroup,
		} = payload;
		const key = 'GetDashboardDetailsBasedonLocKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			UserAreaID: branchID,
			UserBranchID: centerID,
			FunderID: funderID,
			Level: userLevel,
			LoanType: loanType,
			ByCenterGroup: byCenterGroup,
			SetWeekArray: SetWeekArray,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getDashboardAmountBasedonlocationGet, encodeData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getDashboardAmountBasedonlocationFailure(responseData.data));
		} else {
			yield put(getDashboardAmountBasedonlocationSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getDashboardAmountBasedonlocationFailure(error));
	}
}

export function* resetDashboardAmountBasedonlocationResponse() {
	yield put(getDashboardAmountBasedonlocationChanged());
}

export function* onGetDashboardAmountBasedonlocation() {
	yield takeLatest(
		DashboardTypes.GET_DASHBOARD_AMOUNT_BASED_ON_LOCATION_START,
		getDashboardAmountBasedonlocation,
	);
}

export function* onGetDashboardAmountBasedonlocationResponseReset() {
	yield takeLatest(
		DashboardTypes.GET_DASHBOARD_AMOUNT_BASED_ON_LOCATION_RESET,
		resetDashboardAmountBasedonlocationResponse,
	);
}

export function* getDashboardZeroCollectionDetails({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			userID,
			branchID,
			centerID,
			funderID,
			userLevel,
			loanType,
			weekDate,
		} = payload;
		const key = 'getDashBoardZeroCollectionKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			UserAreaID: branchID,
			UserBranchID: centerID,
			FunderID: funderID,
			Level: userLevel,
			LoanType: loanType,
			WeekDate: weekDate,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getDashboardZeroCollectionDetailsGet, encodeData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getDashboardZeroCollectionDetailsFailure(responseData.data));
		} else {
			yield put(getDashboardZeroCollectionDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getDashboardZeroCollectionDetailsFailure(error));
	}
}

export function* resetDashboardZeroCollectionDetailsResponse() {
	yield put(getDashboardZeroCollectionDetailsChanged());
}

export function* onGetDashboardZeroCollectionDetails() {
	yield takeLatest(
		DashboardTypes.GET_DASHBOARD_ZERO_COLLECTION_DETAILS_START,
		getDashboardZeroCollectionDetails,
	);
}

export function* onGetDashboardZeroCollectionDetailsResponseReset() {
	yield takeLatest(
		DashboardTypes.GET_DASHBOARD_ZERO_COLLECTION_DETAILS_RESET,
		resetDashboardZeroCollectionDetailsResponse,
	);
}

export function* getOnlineStaffDetails({ payload }: any) {
	try {
		const { DatabaseName, CompanyID, UserID, BranchID } = payload;
		const key = 'getOnlineStaffDetailsKey';
		const jsonData = {
			DatabaseName: DatabaseName,
			CompanyID: CompanyID,
			UserID: UserID,
			BranchID: BranchID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getOnlineStaffDetailsGet, encodeData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getOnlineStaffDetailsFailure(responseData.data));
		} else {
			yield put(getOnlineStaffDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getOnlineStaffDetailsFailure(error));
	}
}

export function* resetOnlineStaffDetailsResponse() {
	yield put(getOnlineStaffDetailsChanged());
}

export function* onGetOnlineStaffDetails() {
	yield takeLatest(DashboardTypes.GET_ONLINE_STAFF_DETAILS_START, getOnlineStaffDetails);
}

export function* onGetOnlineStaffDetailsResponseReset() {
	yield takeLatest(
		DashboardTypes.GET_ONLINE_STAFF_DETAILS_RESET,
		resetOnlineStaffDetailsResponse,
	);
}

export function* getOfficerLiveStatus({ payload }: any) {
	try {
		const { DatabaseName, CompanyID, BranchID } = payload;
		const key = 'OfficerLiveStatusKey';
		const jsonData = {
			DatabaseName: DatabaseName,
			CompanyID: CompanyID,
			BranchID: BranchID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getOfficerLiveStatusCall, encodeData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getOfficerLiveStatusFailure(responseData.data));
		} else {
			yield put(getOfficerLiveStatusSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getOfficerLiveStatusFailure(error));
	}
}

export function* resetOfficerLiveStatusResponse() {
	yield put(getOfficerLiveStatusChanged());
}

export function* onGetOfficerLiveStatus() {
	yield takeLatest(DashboardTypes.GET_OFFICER_LIVE_STATUS_START, getOfficerLiveStatus);
}

export function* onGetOfficerLiveStatusResponseReset() {
	yield takeLatest(DashboardTypes.GET_OFFICER_LIVE_STATUS_RESET, resetOfficerLiveStatusResponse);
}

/** *********************  GET GOLD LOAN CARD DETAILS START  ******************** */
export function* getGoldLoanCardDetails({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			userLevel,
			userAccessBranchID,
			userID,
			CurrentFinancialYearDataOnDashboard = 0,
		} = payload;
		const key = 'GoldLoanCardDetailsFetchKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			Level: userLevel,
			AreaID: userAccessBranchID,
			UserID: userID,
			CurrentFinancialYearDataOnDashboard: CurrentFinancialYearDataOnDashboard,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getGoldLoanCardDetailsGet, encodeData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getGoldLoanCardDetailsFailure(responseData.data));
		} else {
			yield put(getGoldLoanCardDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getGoldLoanCardDetailsFailure(error));
	}
}

export function* resetGoldLoanCardDetailsResponse() {
	yield put(getGoldLoanCardDetailsResponseChanged());
}

export function* onGetGoldLoanCardDetails() {
	yield takeLatest(DashboardTypes.GET_GOLD_LOAN_CARD_DETAILS_START, getGoldLoanCardDetails);
}

export function* onGetGoldLoanCardDetailsResponseReset() {
	yield takeLatest(
		DashboardTypes.GET_GOLD_LOAN_CARD_DETAILS_RESPONSE_RESET,
		resetGoldLoanCardDetailsResponse,
	);
}
/** ********************* GET GOLD LOAN CARD DETAILS END   ******************** */

/** *********************  GET GOLD LOAN DASHBOARD LOAN DETAILS START  ******************** */
export function* getGoldLoanDashboardLoanDetails({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			userLevel,
			userID,
			userRole,
			SetWeekArray,
			byCenterGroup,
			branchID,
		} = payload;
		const key = 'GoldLoanDashboardLoanDetailsKey';
		const jsonData = {
			UserID: userID,
			CompanyID: companyID,
			UserRoleName: userRole,
			UserLevel: userLevel,
			SetWeekArray: SetWeekArray,
			DatabaseName: databaseName,
			ByCenterGroup: byCenterGroup,
			BranchID: branchID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getGoldLoanDashboardLoanDetailsGet, encodeData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getGoldLoanDashboardLoanDetailsFailure(responseData.data));
		} else {
			yield put(getGoldLoanDashboardLoanDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getGoldLoanDashboardLoanDetailsFailure(error));
	}
}

export function* resetGoldLoanDashboardLoanDetailsResponse() {
	yield put(getGoldLoanDashboardLoanDetailsResponseChanged());
}

export function* onGetGoldLoanDashboardLoanDetails() {
	yield takeLatest(
		DashboardTypes.GET_GOLD_LOAN_DASHBOARD_LOAN_DETAILS_START,
		getGoldLoanDashboardLoanDetails,
	);
}

export function* onGetGoldLoanDashboardLoanDetailsResponseReset() {
	yield takeLatest(
		DashboardTypes.GET_GOLD_LOAN_DASHBOARD_LOAN_DETAILS_RESPONSE_RESET,
		resetGoldLoanDashboardLoanDetailsResponse,
	);
}
/** ********************* GET GOLD LOAN DASHBOARD LOAN DETAILS END   ******************** */

/** ********************* GET GOLD LOAN LOAN INDEX DETAILS START  ******************** */
export function* getGoldLoanLoanIndexDetails({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			userLevel,
			userID,
			userRole,
			SetWeekArray,
			limit,
			searchValueSet,
			branchID,
			userAccessBranchID,
		} = payload;
		const key = 'GoldLoanLoanIndexDetailsKey';
		const jsonData = {
			UserID: userID,
			CompanyID: companyID,
			UserRoleName: userRole,
			UserLevel: userLevel,
			SetWeekArray: SetWeekArray,
			DatabaseName: databaseName,
			Limit: limit,
			SearchLoanIndex: searchValueSet,
			BranchID: branchID,
			AreaID: userAccessBranchID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getGoldLoanLoanIndexDetailsGet, encodeData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getGoldLoanLoanIndexDetailsFailure(responseData.data));
		} else {
			yield put(getGoldLoanLoanIndexDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getGoldLoanLoanIndexDetailsFailure(error));
	}
}

export function* resetGoldLoanLoanIndexDetailsResponse() {
	yield put(getGoldLoanLoanIndexDetailsResponseChanged());
}

export function* onGetGoldLoanLoanIndexDetails() {
	yield takeLatest(
		DashboardTypes.GET_GOLD_LOAN_LOAN_INDEX_DETAILS_START,
		getGoldLoanLoanIndexDetails,
	);
}

export function* onGetGoldLoanLoanIndexDetailsResponseReset() {
	yield takeLatest(
		DashboardTypes.GET_GOLD_LOAN_LOAN_INDEX_DETAILS_RESPONSE_RESET,
		resetGoldLoanLoanIndexDetailsResponse,
	);
}
/** ********************* GET GOLD LOAN LOAN INDEX DETAILS END   ******************** */

export function* dashboardSaga() {
	yield all([
		call(onGetDashboardDetails),
		call(onGetDashboardDetailsResponseReset),

		call(onRejectMemberList),
		call(onRejectMemberListResponseReset),
		call(onGetDashboardDetailsLoanType),
		call(onGetDashboardDetailsLoanTypeResponseReset),
		call(onGetLoanDetails),
		call(onGetLoanDetailsResponseReset),
		call(onGetLoanIndexDetails),
		call(onGetLoanIndexDetailsResponseReset),
		call(onGetCompanyEodStatus),
		call(onGetCompanyEodStatusResponseReset),
		call(onDashboardParticularDetails),
		call(onDashboardParticularDetailsResponseReset),
		call(onDashboardStaffCollection),
		call(onDashboardStaffCollectionResponseReset),
		call(onDashboardStaffLocation),
		call(onDashboardStaffLocationResponseReset),
		// DEMAND SECTION
		call(onParticularDateDemand),
		call(onParticularDateDemandResponseReset),
		call(onParticularDateDemandInfo),
		call(onParticularDateDemandInfoResponseReset),
		call(onParticularDateMemberAbsent),
		call(onParticularDateMemberAbsentResponseReset),
		// COLLECTION SECTION
		call(onParticularDateCollection),
		call(onParticularDateCollectionResponseReset),
		call(onParticularDateCollectionInfo),
		call(onParticularDateCollectionInfoResponseReset),
		call(onWeekCollection),
		call(onWeekCollectionResponseReset),
		call(onWeekYTCollection),
		call(onWeekYTCollectionResponseReset),
		// SMS USED LIST SECTION
		call(onGetSMSUsedList),
		call(onGetSMSUsedListResponseReset),
		// KYC USED LIST SECTION
		call(onGetKYCUsedList),
		call(onGetKYCUsedListResponseReset),
		// ARREAR COLLECTION LIST SECTION
		call(onGetArrearCollectionList),
		call(onGetArrearCollectionListResponseReset),
		// DASHBOARD STAFF MAP COLLECTION SECTION
		call(onGetDashboardStaffMapCollectionStart),
		call(onGetDashboardStaffMapCollectionStartResponseReset),
		call(onGetDashboardCollectionNoteInfoStart),
		call(onGetDashboardCollectionNoteInfoStartResponseReset),
		call(onGetDashboardSavingsAndFD),
		call(onGetDashboardSavingsAndFDResponseReset),
		call(onGetDashboardTotalBranchMember),
		call(onGetDashboardTotalBranchMemberResponseReset),
		call(onGetBranchTotalInvestmentAmount),
		call(onGetBranchTotalInvestmentAmountResponseReset),
		call(onGetTotalCollection),
		call(onGetTotalCollectionResponseReset),
		call(onGetBranchTotalOLBAmount),
		call(onGetBranchTotalOLBAmountResponseReset),
		call(onGetDashboardAmountBasedonlocation),
		call(onGetDashboardAmountBasedonlocationResponseReset),
		call(onGetDashboardZeroCollectionDetails),
		call(onGetDashboardZeroCollectionDetailsResponseReset),
		call(onGetOnlineStaffDetails),
		call(onGetOnlineStaffDetailsResponseReset),
		call(onGetOfficerLiveStatus),
		call(onGetOfficerLiveStatusResponseReset),
		call(onGetGoldLoanCardDetails),
		call(onGetGoldLoanCardDetailsResponseReset),
		call(onGetGoldLoanDashboardLoanDetails),
		call(onGetGoldLoanDashboardLoanDetailsResponseReset),
		call(onGetGoldLoanLoanIndexDetails),
		call(onGetGoldLoanLoanIndexDetailsResponseReset),
	]);
}
